export const SET_TREND_SUMMARY_CAMPAIGNS = "SET_TREND_SUMMARY_CAMPAIGNS"
export const SET_TREND_SUMMARY_HISTORICAL_SCORES =
  "SET_TREND_SUMMARY_HISTORICAL_SCORES"
